import { useMemo, useState } from 'react';
export const getMediaItems = (highlights, screenshots) => {
  const highlightsMedia = highlights.map(highlight => ({
    dataURI: highlight.image.url,
    name: highlight.title || highlight.caption || 'Highlight'
  }));
  const screenshotMedia = screenshots === null || screenshots === void 0 ? void 0 : screenshots.map(screenshot => ({
    dataURI: screenshot.image.url,
    name: screenshot.caption || 'Screenshot'
  }));
  return [...(screenshotMedia || []), ...(highlightsMedia || [])];
};
export const useMedia = (highlights, screenshots) => {
  const mediaItems = useMemo(() => getMediaItems(highlights, screenshots), [highlights, screenshots]);
  const [activeMedia, setActiveMedia] = useState(null);
  const handleMediaClick = item => {
    setActiveMedia(item);
  };
  const unsetActiveMedia = () => {
    setActiveMedia(null);
  };
  return {
    mediaItems,
    activeMedia,
    handleMediaClick,
    unsetActiveMedia
  };
};